import moment from 'moment';
import { each, isNil } from 'lodash';
import { x } from '../_helpers';
import { localTimeHook } from '../_helpers/constants';

export default class LocalTime {
  constructor() {
    this.items = x(localTimeHook);
  }

  initItem(el) {
    const utcTime = moment.utc(el.attributes['data-utc-time'].value);
    const timeFormat = el.attributes['data-format']?.value;
    const dateFormat = el.attributes['data-date-format']?.value;

    if (isNil(utcTime)) {
      return;
    }

    if (!isNil(timeFormat)) {
      el.innerText = utcTime.local().format(timeFormat);
    }

    if (!isNil(dateFormat)) {
      el.innerText = " - " + utcTime.local().format(dateFormat);
    }
  }

  initItems(items) {
    this.items = items;
    this.init();
  }

  handleEvents() {
    each(this.items, (element) => {
      this.initItem(element);
    });
  }

  init() {
    if (this.items) {
      this.handleEvents();
    }
  }
}
